export default "__VITE_ASSET__rNUZTraB__"